import styled, { css, keyframes } from 'styled-components';
import { getSpacingToken, getToken, Stack, StackItem } from '@optimus-web/core';
import { CHART_ANIMATION_CONFIG } from '../common';

const width = (value: number) => keyframes`
    0% {
        width: 0;
    }
    100% {
        width: ${value}%;
    }
`;

const barHeight = getSpacingToken('50');

export const ProgressContainer = styled(Stack)<{ minWidth?: string }>`
    min-width: ${({ minWidth }) => minWidth};
    height: ${barHeight}px;
    background: ${getToken('backgroundInteractiveNeutralDefault')};
    overflow: hidden;
    border-radius: ${({ theme }) => barHeight({ theme }) / 2}px;
`;
interface ProgressValueProps {
    value: number;
    multipleValues: boolean;
    animation: boolean;
    cornerRadius: boolean;
}

export const ProgressValue = styled(StackItem)<ProgressValueProps>`
    background-color: ${getToken('backgroundStaticFlat')};

    ${({ animation, value }) =>
        animation
            ? css`
                  animation-duration: ${CHART_ANIMATION_CONFIG.animationDuration}ms;
                  animation-timing-function: ${CHART_ANIMATION_CONFIG.animationEasing};
                  animation-delay: ${CHART_ANIMATION_CONFIG.animationBegin}ms;
                  animation-iteration-count: 1;
                  animation-fill-mode: forwards;
                  animation-name: ${width(value)};
              `
            : css`
                  width: ${value}%;
              `}

    ${({ multipleValues }) =>
        multipleValues &&
        css`
            &:not(:last-child) {
                padding-right: 2px;
            }
        `}

    ${({ multipleValues, cornerRadius, theme }) =>
        multipleValues &&
        cornerRadius &&
        css`
            &:last-child {
                ${ProgressValueInner} {
                    border-top-right-radius: ${barHeight({ theme }) / 2}px;
                    border-bottom-right-radius: ${barHeight({ theme }) / 2}px;
                }
            }
        `}
`;

interface ProgressValueInnerProps {
    progressColor: string;
    cornerRadius: boolean;
    multipleValues: boolean;
}

export const ProgressValueInner = styled.div<ProgressValueInnerProps>`
    background-color: ${({ progressColor }) => progressColor};
    height: 100%;

    ${({ cornerRadius, theme, multipleValues }) =>
        cornerRadius &&
        !multipleValues &&
        css`
            border-radius: ${barHeight({ theme }) / 2}px;
        `}
`;
